/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEmploymentsForPerson} from '../api'

 export const useQueryGetEmploymentsForPerson = createReactQueryHook('getEmploymentsForPerson', getEmploymentsForPerson)
